const initState = {
    incidents: [],
    incidentsScopeKey: null,
    incident: null,
    gotoIncident: null,
};

const incidentsScopeKey = (scopeType, scopeId) => `${scopeType}:${scopeId ?? 0}`;

const incidentReducer = (state = initState, action) => {


    switch (action.type) {

        case "RESET_GOTO_INCIDENT":
            return {
                ...state,
                gotoIncident: null,
            };

        case "GOTO_INCIDENT":
            return {
                ...state,
                gotoIncident: action.risk_id,
            };

        case "INCIDENTS_REQUEST": {
            const nextKey = incidentsScopeKey(action.scopeType, action.scopeId);
            const isScopeChange = nextKey !== state.incidentsScopeKey;
            return {
                ...state,
                incidents: isScopeChange ? [] : state.incidents,
                incidentsScopeKey: nextKey,
            };
        }

        case "INCIDENTS":
            if (
                action.scopeKey != null &&
                state.incidentsScopeKey != null &&
                action.scopeKey !== state.incidentsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                incidents: action.incidents,
                incidentsScopeKey: action.scopeKey ?? state.incidentsScopeKey,
            };

        case "INCIDENT":
            return {
                ...state,
                incident: action.incident,
            };
        case "CLOSE_INCIDENT":
            return {
                ...state,
                incident: null,
            };

        default:
            return state;
    }
};

export default incidentReducer;
